// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__8vb6R","noInteraction":"EventWrapper_noInteraction__1AVCC","pointerPassthrough":"EventWrapper_pointerPassthrough__33TiW"};